import { getAxiosInstance } from "../Config";

// * get patient id list based on country and phase
export const getPatientIdList = async (country, phase) => {
  const axiosInstance = await getAxiosInstance();
  return axiosInstance
    .get(`/history/getPatientIdList`
        , {
        params: {
            country: country,
            phase: phase,
            },
        } 
    )
    .then((response) => {
      if (response.status !== 200) {
        throw new Error(`Error: ${response.data}`);
      }
      return response.data;
    })
    .catch((error) => {
      console.error(error.message);
      alert(error.message);
    });
};

// get message history based on patient id
export const getMessageHistory = async (patientId) => {
  const axiosInstance = await getAxiosInstance();
  return axiosInstance
    .get(`/history/getPatientMsgHistory/${patientId}`)
    .then((response) => {
      if (response.status !== 200) {
        throw new Error(`Error: ${response.data}`);
      }
      return response.data;
    })
    .catch((error) => {
      console.error(error.message);
      alert(error.message);
    });
};